<script>
    import { push } from "svelte-spa-router";
    import GeneralLayout from "../../../../common/GeneralLayout.svelte";
    import HeaderBar from "../../../../components/header/HeaderBar.svelte";
    import AudioItem from "../../components/audio-player/AudioItem.svelte";
    import { _ } from "svelte-i18n";
    import { getEntities, getEntity } from "../../../../api-client";
    import MediaQuery from "svelte-media-query";
    import LoadingSquare from "../../../../common/LoadingSquare.svelte";

    export let params = {};
    $: if (params.id) {
        window.scrollTo(0, 0);
    }
    $: podcastId = params.id;

    $: promise = Promise.all([
        getEntity("podcast", podcastId),
        getEntities("podcast_episode"),
    ]).then(([podcast, episodes]) => {
        if (podcast && episodes) {
            podcast.episodes = episodes.filter((episode) =>
                (podcast.fk_episodes ?? []).includes(episode.id)
            );
            return podcast;
        }
    });

    let showMore = false;
</script>

{#await promise}
    <LoadingSquare />
{:then podcast}
    <div class="display-small">
        <HeaderBar title={podcast.headerTitle} />
    </div>
    <GeneralLayout>
        <div slot="firstSegment">
            <div class="display-big">
                <HeaderBar hideSeperator />
            </div>
            <div class="headline-m title">{podcast.title}</div>

            {#if podcast.description}
                <MediaQuery query="(min-width: 1440px)" let:matches>
                    {#if matches}
                        <div class="text-m description">
                            {@html podcast.description}
                        </div>
                    {:else}
                        <div class="text-m description" class:small={!showMore}>
                            {@html podcast.description}
                        </div>
                        <div
                            class="description-button"
                            style="cursor: pointer"
                            on:click={() => (showMore = !showMore)}
                        >
                            <img
                                src={showMore
                                    ? "/images/icons/minus.svg"
                                    : "/images/icons/plus.svg"}
                                alt={$_("show_more")}
                                class="more-icon"
                            />
                            <span class="text-m"
                                >{showMore
                                    ? $_("show_less")
                                    : $_("show_more")}</span
                            >
                        </div>
                    {/if}
                </MediaQuery>
            {/if}
            <div class="divider-h segment-divider" />
        </div>
        <div slot="secondSegment">
            <div class="secondSegment-wraper">
                {#each podcast.episodes as episode, index}
                    <div
                        class="content-wrapper"
                        on:click={() =>
                            push(`/podcasts/${podcast.id}/${episode.id}`)}
                    >
                        <AudioItem
                            audioGuide={episode}
                            showDuration={true}
                            customThumbnail={podcast.image}
                        />
                    </div>
                    {#if index < podcast.episodes.length - 1}
                        <div class="divider">
                            <div class="divider-h" />
                        </div>
                    {/if}
                {/each}
                <div />
            </div>
        </div>
    </GeneralLayout>
{:catch}
    <div class="error">
        <span class="text-l" style="font-size: 24px;">
            {$_("entity_load_error")}
        </span>
    </div>
{/await}

<style>
    .title {
        margin: 32px 16px;
    }

    .divider {
        padding: 16px 16px;
    }

    .content-wrapper {
        padding-bottom: 0px;
        padding: 0 16px;
    }

    .description {
        margin: 0 16px;
    }

    .small {
        max-height: 64px;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-top: -16px;
    }

    .more-icon {
        margin-right: 8px;
        width: 16px;
        height: 16px;
    }

    .description-button {
        display: flex;
        align-items: center;
        margin: 16px 16px 32px 16px;
    }

    .segment-divider {
        margin: 16px 16px;
        width: auto;
    }

    .secondSegment-wraper {
        padding-bottom: 32px;
    }

    @media (min-width: 1440px) {
        .title {
            margin: 10px 24px 16px 16px;
        }

        .content-wrapper {
            padding-bottom: 16px;
            padding-left: 24px;
        }

        .divider {
            padding: 32px 48px 24px 16px;
        }

        .segment-divider {
            display: none;
        }

        .secondSegment-wraper {
            padding-top: 72px;
        }
    }
</style>
